import { Typography, useTheme } from '@mui/material';

import { ATSConnectHiringRequestCreateFeedbackTestIds } from 'data-testids/ATS';
import { ScorecardQuestionAndAnswerSectionProps } from './types';
import { useGetCumulativeScore } from './util';
import { SharedQuestionAndAnswerSection } from 'sharedComponents/Questions/components/SharedQuestionAndAnswerSection';

export const ErrorText: React.FC<{ dataTestId: string }> = ({ dataTestId }) => {
  const theme = useTheme();

  return (
    <Typography
      data-testid={dataTestId}
      sx={{ paddingTop: theme.spacing(1), color: theme.palette.error.main }}
    >
      This field is required
    </Typography>
  );
};

export const ScorecardQuestionAndAnswerSection: React.FC<
  ScorecardQuestionAndAnswerSectionProps
> = ({ answers, question, index }) => {
  const updateCumulativeScore = useGetCumulativeScore();

  return (
    <SharedQuestionAndAnswerSection
      answers={answers}
      index={index}
      onCumulativeScoreUpdate={updateCumulativeScore}
      question={question}
      testIdPrefix={ATSConnectHiringRequestCreateFeedbackTestIds.SCORECARD_QUESTION}
    />
  );
};
